<div *ngIf="projectConfigurationService.currentConfigData" style="display: flex;  background-color: black; color: whitesmoke">
    <div class="logo">
        <img *ngIf="projectConfigurationService.currentConfigData.login_logo" style="margin: auto; width: 200px; "
            src="assets/img/{{ projectConfigurationService.currentConfigData.login_logo }}">
    </div>
    <div style="display: flex; flex-direction: row; width: 100%; justify-content:space-evenly; color: whitesmoke">
        <div class="column">
            <div class="row">About us</div>
            <div class="row"> Contact us</div>
            <div class="row">FAQ & help</div>
        </div>
        <div class="column">
            <div class="row">Terms of use</div>
            <div class="row"> Contact us</div>
            <div class="row">FAQ & help</div>
        </div>
    </div>
</div>